namespace TabAurous.Common {
    export interface Issue {
        ProductCode?: string;
        AttributeType?: string;
        AttributeCode?: string;
    }
}
